export enum EContactType {
	patient = 1,
	contact = 2
}